import { render } from "./perpustakaanDigital.vue?vue&type=template&id=da3e5f36"
import script from "./perpustakaanDigital.vue?vue&type=script&lang=js"
export * from "./perpustakaanDigital.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__